// A confirmed provider draft remains a draft. Only the existing explicit human
// confirmation can request a separately durable, rep-confirmed outcome receipt.
export function outcomeDraftReference(result,proof){
 if(!result?.draftId)return null
 if(proof&&result.attemptId)return {kind:'artwork',jobId:proof.workspaceJobId,attemptId:result.attemptId}
 if(result.requestId)return {kind:'dossier',requestId:result.requestId}
 return null
}
export function verifiedOutcomeResponse(result,expected){
 const r=result?.receipt
 const sameDraft=r?.draft&&expected.draft&&Object.keys(r.draft).length===Object.keys(expected.draft).length&&Object.keys(expected.draft).every(k=>r.draft[k]===expected.draft[k])
 return result?.ok===true&&result.logged===true&&result.requestId===expected.requestId&&result.provenance==='rep-confirmed'&&r?.schema==='rep-confirmed-outcome-v1'&&/^[1-9][0-9]*$/.test(r.id)&&r.recordId===expected.championshipId&&r.actorId===expected.actorId&&r.kind===expected.kind&&r.provenance==='rep-confirmed'&&r.providerVerified===false&&typeof r.recordedAt==='string'&&Number.isFinite(Date.parse(r.recordedAt))&&/^[a-f0-9]{64}$/.test(r.bindingDigest)&&sameDraft
}
export async function recordConfirmedOutcome({send,request,actorId,isCurrent=()=>true}){
 const result=await send(request)
 if(!isCurrent())throw new Error('The selected record changed. Refresh its recorded history.')
 if(!verifiedOutcomeResponse(result,{...request,actorId}))throw new Error('No matching durable outcome receipt was returned. The send is not recorded here; retry the same confirmation to reconcile it.')
 return result.receipt
}
